module.exports = __webpack_public_path__ + "img/star.bd8315dc.svg";